var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',[_c('v-card',{staticClass:"rounded-lg"},[_c('v-card-text',[_c('h3',[_vm._v(" Logistica y Almacén ")])])],1)],1)],1),_c('InternalMenuLogistic')],1)}
var staticRenderFns = []

export { render, staticRenderFns }